import { FormControl, InputLabel, TextField, Grid } from '@mui/material'
import React from 'react'

const PupilSize = ({ moduleValues, setModuleValues, side }) => (
  <Grid item xs={12} lg={6}>
    <TextField
      label="Pupil Size (mm)"
      value={moduleValues?.[`Pupil Size (${side})`] ?? ''}
      onChange={(e) =>
        setModuleValues((prev) => ({
          ...prev,
          [`Pupil Size (${side})`]: e.target.value,
        }))
      }
      fullWidth
    />
  </Grid>
)

export default PupilSize
